import registerFocus from './resize'; // 获取焦点
import integerOnly from './integerOnly'; // 获取焦点
 
export default function registerDirectives(app: any) {
    registerFocus(app);
    integerOnly(app);
}